import { Vector3 } from 'three';
import generalCalculation from './generalCalculation';
import Axis from '@scene/axis';

export default {
  ...generalCalculation,
  orthographicCamera: {
    ...generalCalculation.orthographicCamera,
    position: new Vector3(10, 0, 0)
  },
  perspectiveCamera: {
    position: new Vector3(742.7879540262978, 142.10544011102013, 759.3002519688974),
    target: new Vector3(61.911263501388774, -33.2887594838193, -91.75690968561267),
    zoom: 1
  },
  axis: {
    position: null,
    orientation3D: Axis.types.Y_TOP,
    orientation2D: Axis.types.Y_TOP_2D
  }
};



// WEBPACK FOOTER //
// ./src/reducers/camera/defaults/bracketAttachment.js